import { TokenService } from '@core/modules/auth/services/token.service';

export function appInitializerFactory(authService: TokenService) {
  return () => {
    return authService.refreshToken(true).toPromise();
  };
}
